import {redirect} from 'react-router-dom';

import {getGroups} from '@/services/authService';
import {
  forcedWorkTimeTrackingGroups,
  isEmployeeWorkTimeTrackingForced as isEmployeeForced,
} from '@/shared/work-time/utils/workTimeGroups';
import isCurrentClientEntitle from '@/utils/isCurrentClientEntitled';
import isCurrentWorkTimeSessionActive from '@/utils/isCurrentWorkTimeSessionActive';
import isEmployeeWorkTimeTrackingForced from '@/utils/isEmployeeWorkTimeTrackingForced';
import isGroupAuthorized from '@/utils/isGroupAuthorized';
import {
  authenticatedRootLoader,
  isLoaderRedirect,
} from '@/utils/protectedLoader';

export const rootLoader = async () => {
  const authResult = await authenticatedRootLoader();

  return isLoaderRedirect(authResult) ? authResult : null;
};

export const workStartedLoader = async () => {
  const groups = await getGroups();
  if (!groups.length) return null;

  const isWorkTimeEntitled = await isCurrentClientEntitle('WORK_TIME');

  if (!isWorkTimeEntitled) return null;

  const isEmployee = isGroupAuthorized(groups, forcedWorkTimeTrackingGroups);
  if (!isEmployee) return null;

  const forceTrackingEnabled = await isEmployeeWorkTimeTrackingForced();
  const isWorkTimeForced = isEmployeeForced(groups, forceTrackingEnabled);
  const hasActiveWorkSession =
    isWorkTimeForced && (await isCurrentWorkTimeSessionActive());

  if (isWorkTimeForced && !hasActiveWorkSession) {
    return redirect('/work-time/start');
  }

  return null;
};
